export enum LandingPageComponentAlignment {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
